import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvestmentNegotiationService {

  constructor(private readonly http: HttpClient) { }

  async getInvestmentNegotiation(): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/investment-negotiation`;
    return await this.http.get(url).toPromise();
  }
}
